import React from 'react';

import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import registry from 'react-mui-lib/registry';


function fmtDT(v) {
    if (!v) return '—';
    return v.replace('T', ' ').substring(0, 16);
}


class Mailer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            stats: {},
            file: null,
            uploading: false,
            toggling: false,
            message: '',
            messageError: false,
        };
        this.restClient = registry.get('rest_client');
        this.fileInput = React.createRef();
    }

    componentDidMount() {
        this.loadStats();
    }

    loadStats() {
        this.restClient.get('mail/stats').then(stats => {
            this.setState({ stats, loading: false });
        }).catch(() => {
            this.setState({ loading: false, message: 'Не удалось загрузить статистику' });
        });
    }

    onFileChange = (e) => {
        this.setState({ file: e.target.files[0] || null });
    }

    onUpload = () => {
        const { file } = this.state;
        if (!file) return;
        this.setState({ uploading: true, message: '' });
        this.restClient.request({
            url: '/admin/rest/mail/upload',
            method: 'POST',
            send_as: 'formdata',
            data: { file }
        }).then(r => {
            if (r.status !== 'ok') {
                this.setState({ uploading: false, messageError: true,
                                message: r.message || 'Ошибка загрузки' });
                return;
            }
            this.setState({
                uploading: false,
                file: null,
                messageError: false,
                message: `Загружено: новых компаний ${r.imported}, новых email ${r.new_emails}` +
                         (r.dup_contacts ? `, дублей компаний ${r.dup_contacts}` : '') +
                         (r.dup_emails ? `, дублей email ${r.dup_emails}` : '') +
                         (r.edited_skipped ? `, пропущено правленых ${r.edited_skipped}` : '') +
                         (r.no_email ? `, без email ${r.no_email}` : '')
            });
            if (this.fileInput.current) this.fileInput.current.value = '';
            this.loadStats();
        }).catch(err => {
            const resp = err && err.json_response;
            const msg = (resp && resp.message) || 'Ошибка загрузки файла';
            this.setState({ uploading: false, messageError: true, message: msg });
        });
    }

    onToggle = () => {
        const enabled = !this.state.stats.enabled;
        this.setState({ toggling: true, message: '' });
        this.restClient.post('mail/toggle', { enabled }).then(() => {
            this.setState({ toggling: false });
            this.loadStats();
        }).catch(() => {
            this.setState({ toggling: false, message: 'Не удалось переключить рассылку' });
        });
    }

    render() {
        const { loading, stats, file, uploading, toggling, message, messageError } = this.state;

        if (loading) {
            return <Paper style={{ padding: 24, margin: 16 }}><CircularProgress /></Paper>;
        }

        const enabled = !!stats.enabled;
        const deferred = stats.queue_deferred === null || stats.queue_deferred === undefined ? '—' : stats.queue_deferred;

        return <div style={{ padding: 16, maxWidth: 720 }}>
            <Paper style={{ padding: 16, marginBottom: 16 }}>
                <Typography variant="subtitle1" style={{ fontWeight: 600 }}>Загрузка базы (xlsx)</Typography>
                <div style={{ margin: '8px 0' }}>
                    <input type="file" accept=".xlsx" ref={this.fileInput} onChange={this.onFileChange} />
                    <Button variant="contained" color="primary" size="small"
                            disabled={!file || uploading}
                            onClick={this.onUpload}
                            style={{ marginLeft: 8 }}>
                        {uploading ? 'Загружаю…' : 'Загрузить'}
                    </Button>
                </div>
                <Typography variant="body2" color="textSecondary">
                    Дедубликация по названию+городу.
                </Typography>
                {stats.last_import_at &&
                    <Typography variant="body2" style={{ marginTop: 4 }}>
                        Последняя загрузка базы: {fmtDT(stats.last_import_at)}. Компаний в базе: {stats.contacts_total}.
                    </Typography>
                }
                {message &&
                    <Typography variant="body2" style={{ marginTop: 8, color: messageError ? '#c62828' : 'inherit' }}>
                        {message}
                    </Typography>
                }
            </Paper>

            <Paper style={{ padding: 16, marginBottom: 16 }}>
                <Typography variant="subtitle1" style={{ fontWeight: 600, display: 'inline' }}>
                    Рассылка: {enabled ? 'ВКЛЮЧЕНА' : 'ВЫКЛЮЧЕНА'}
                </Typography>
                <Button variant="contained" color={enabled ? 'secondary' : 'primary'} size="small"
                        disabled={toggling}
                        onClick={this.onToggle}
                        style={{ marginLeft: 16 }}>
                    {enabled ? 'Остановить' : 'Запустить'}
                </Button>
                <Typography variant="body2" style={{ marginTop: 8 }}>
                    Сегодня отправлено: {stats.sent_today} писем / лимит {stats.day_cap}&nbsp;&nbsp;
                    осталось в очереди: {enabled ? stats.queue_left : '—'}&nbsp;&nbsp;
                    отложено в очереди сервера: {deferred}
                </Typography>
            </Paper>

            <Paper style={{ padding: 16 }}>
                <Typography variant="body2">Рассылка — старт: {fmtDT(stats.started_at)}&nbsp;&nbsp;финиш: {fmtDT(stats.finished_at)}</Typography>
                <Typography variant="body2">Отправлено: {stats.sent_companies} компаний / {stats.sent_emails} писем</Typography>
                <Typography variant="body2">Не доставлено: {stats.bounced}</Typography>
                <Typography variant="body2">Отписались: {stats.unsubbed}</Typography>
                <Typography variant="body2">Отложено на повтор: {stats.resend_pending}</Typography>
                <Typography variant="body2">Перешли на сайт: {stats.clicks}</Typography>
                <Typography variant="body2">Промокоды: выдано {stats.promo_issued || 0} / активировано {stats.promo_activated || 0}</Typography>
            </Paper>

        </div>;
    }
}

export default Mailer;
